<template>
    <div class="relative flex flex-col h-screen">
        <img :src="getImage('mascot')" class="fixed papsi-mascot">

        <div class="flex flex-1 lg:flex-row flex-col">
            <SidebarSection>
                <LabelControl type="message" :content="$t('has001')" />
            </SidebarSection>

            <ContentSection @logout="logout">
                <LabelControl type="heading" :content="$t('has002')" />
                <div class="mt-10 bg-grey-lighter p-10 rounded-xl container">

                    <div class="overflow-y-auto text-justify">
                        <!-- <div @click="handleRedirect('/help/end-user-license-agreement')"
                            class="bg-white rounded-xl flex items-center justify-between px-8 py-12 mb-10 cursor-pointer">
                            <LabelControl type="dynamic" class="text-4xl text-grey-darker font-semibold"
                                :content="$t('has003')" />
                            <img :src="getIcon('next-grey')">
                        </div> -->

                        <div @click="handleRedirect('/help/privacy-policy')"
                            class="bg-white rounded-xl flex items-center justify-between px-8 py-12 mb-10 cursor-pointer">
                            <LabelControl type="dynamic" class="text-4xl text-grey-darker font-semibold"
                                :content="$t('has004')" />
                            <img :src="getIcon('next-grey')">
                        </div>

                        <div @click="handleRedirect('/help/contact-support')"
                            class="bg-white rounded-xl flex items-center justify-between px-8 py-12 cursor-pointer">
                            <LabelControl type="dynamic" class="text-4xl text-grey-darker font-semibold"
                                :content="$t('has005')" />
                            <img :src="getIcon('next-grey')">
                        </div>
                    </div>

                </div>

            </ContentSection>
        </div>

        <FooterSection />
    </div>
</template>

<script>
import SidebarSection from '@/components/sections/SidebarSection.vue';
import ContentSection from '@/components/sections/ContentSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import mixin from '@/mixins/controls.js';
import LabelControl from '@/components/controls/LabelControl.vue';

export default {
    mixins: [mixin],
    components: {
        SidebarSection,
        ContentSection,
        FooterSection,
        LabelControl,
    },
    mounted() {
        this.$emit('checkauth');
    },
    methods: {
        logout() {
            this.$emit('logout');
        },
    },
};
</script>

<style scoped>
.papsi-mascot {
    bottom: 0;
    left: 0;
    width: 25rem;
}

.papsi-container {
    height: 36rem;
}

@media (min-width: 2500px) {
  .container img {
    height: 2rem !important;
    width:  2rem !important;
  }

}

</style>
